import {
  GET_CR_VISITS_SUCCESS,
  GET_CR_PAST_SUMMARY_SUCCESS,
  GET_CR_FUTURE_SUMMARY_SUCCESS,
  GET_CR_LONG_VISITS_SUCCESS,
  CREATE_VISITS,
  GET_PREVIOUS_VISIT,
  GET_PRIORITY_INBOX_VISIT_COUNT,
  GET_REASONS,
  GET_SIMILAR_VISITS,
  API_SHORT_VISITS,
  API_LONG_VISITS,
  API_PAST_SUMMARY,
  API_FUTURE_SUMMARY,
  API_CREATE_VISITS,
  API_PREVIOUS_VISIT,
  API_PI_VISIT_COUNTS,
  API_GET_REASONS,
  API_SIMILAR_VISITS,
  API_UPCOMING_VISITS,
  GET_UPCOMING_VISITS,
  UNDEF,
} from "../Constants";
import Api, { showSnackbar } from "../Api";
import { dateFormat } from "../Util/DateUtils";

export const getCRShortVisits = (_id: string, d1: Date, d2: Date) => {
  const startDate = dateFormat(d1); //convert to YYYY-MM-DD format
  const endDate = dateFormat(d2); //convert to YYYY-MM-DD format
  return (dispatch: any) => {
    Api.GET(
      `${API_SHORT_VISITS}${_id}/${startDate}/${endDate}`,
      (resp?: any) => {
        resp &&
          dispatch({ type: GET_CR_VISITS_SUCCESS, visits: resp.data.visits });
      },
      false,
      true
    );
  };
};

export const getCRFullVisits = (_id: string, d1: Date, d2: Date) => {
  const startDate = dateFormat(d1); //convert to YYYY-MM-DD format
  const endDate = dateFormat(d2); //convert to YYYY-MM-DD format
  return (dispatch: any) => {
    Api.GET(
      `${API_LONG_VISITS}${_id}/${startDate}/${endDate}`,
      (resp?: any) => {
        resp &&
          dispatch({
            type: GET_CR_LONG_VISITS_SUCCESS,
            fullVisits: resp.data.visits,
          });
      },
      false,
      true
    );
  };
};

export const getCareRecipientPastVisitSummary = (_id: string) => {
  return (dispatch: any) => {
    Api.GET(
      `${API_PAST_SUMMARY}${_id}`,
      (resp?: any) => {
        resp &&
          dispatch({
            type: GET_CR_PAST_SUMMARY_SUCCESS,
            pastSummary: resp.data,
          });
      },
      false,
      false
    );
  };
};

export const getCareRecipientFutureVisitSummary = (_id: string) => {
  return (dispatch: any) => {
    Api.GET(
      `${API_FUTURE_SUMMARY}${_id}`,
      (resp?: any) => {
        resp &&
          dispatch({
            type: GET_CR_FUTURE_SUMMARY_SUCCESS,
            futureSummary: resp.data,
          });
      },
      false,
      false
    );
  };
};

export const createVisits = (visitDrafts: any[], recipientId: string) => {
  return (dispatch: any) => {
    //const test = JSON.parse(JSON.stringify(visitDrafts));
    //delete test[0].visit_schedule;

    Api.POST(
      API_CREATE_VISITS,
      { visitDrafts, recipientId },
      (resp: any, err: any) => {
        resp &&
          dispatch({
            type: CREATE_VISITS,
            visitDraftsToDelete: visitDrafts,
          });
        if (err) {
          const resp = err.response;
          const data = resp && resp.data;
          const createdCount = data && data.data && data.data.createdVisitCount;
          if (!createdCount) {
            const retryFn = () =>
              createVisits(visitDrafts, recipientId)(dispatch);
            showSnackbar(
              "Unable to create visits, please try again.",
              "error",
              UNDEF,
              "Retry",
              retryFn
            );
          } else {
            const len = visitDrafts.length;
            const visits = "visit" + (len > 1 ? "s" : "");
            const message = `${createdCount} out of ${len} ${visits} created.\nEncountered some errors while scheduling the ${visits}. Please contact technical support.`;
            showSnackbar(message, "error");
          }
        }
      },
      false,
      false
    );
  };
};

export const getPreviousVisit = (recipientId: string) => {
  return (dispatch: any) => {
    Api.GET(
      `${API_PREVIOUS_VISIT}${recipientId}`,
      (resp?: any) => {
        resp &&
          resp.data.success &&
          dispatch({
            type: GET_PREVIOUS_VISIT,
            previousVisit: resp.data.previousVisit,
          });
      },
      false,
      false
    );
  };
};

export const getPriorityInboxCount = () => {
  return (dispatch: any) => {
    Api.GET(
      API_PI_VISIT_COUNTS,
      (resp) => {
        resp &&
          dispatch({
            type: GET_PRIORITY_INBOX_VISIT_COUNT,
            priorityInboxVisitCount: resp.data.priority_count,
          });
      },
      false,
      true
    );
  };
};

export const getReasons = () => {
  return (dispatch: any) => {
    Api.GET(
      API_GET_REASONS,
      (resp) => {
        resp &&
          dispatch({
            type: GET_REASONS,
            reasons: resp.data,
          });
      },
      false,
      true,
      true
    );
  };
};

export const getSimilarVisits = (visitId: string) => {
  return (dispatch: any) => {
    Api.GET(
      API_SIMILAR_VISITS + visitId,
      (resp) => {
        resp &&
          dispatch({
            type: GET_SIMILAR_VISITS,
            similarVisits: resp.data.visits,
          });
      },
      false,
      true,
      true
    );
  };
};

export const getUpcomingVisits = (crId: string, excludingVisitId: string) => {
  return (dispatch: any) => {
    Api.GET(
      API_UPCOMING_VISITS + crId,
      (resp) => {
        resp &&
          dispatch({
            type: GET_UPCOMING_VISITS,
            upcomingVisits: resp.data.visits.filter(
              (v: any) => v.visit_id !== excludingVisitId
            ),
          });
      },
      false,
      true,
      true
    );
  };
};
